/**
 * Extracts relative path from the url path.
 * @param path The URL path.
 * @returns The path without base url, origin domain
 * @category Utils
 */
export const getRelativeUrl = (path: string) => {
  try {
    if (path.startsWith('/')) return path

    const { origin } = new URL(path)
    return path.replace(origin, '')
  }
  catch {
    return path
  }
}
